import railyApiService from "../raily-api.service";
import contractsCargoTaxiAddRequestFactory from "./cargo-taxi/add/contracts-cargo-taxi-add-request.factory";
import ContractsCargoTaxiAddRequest, {
  ContractsCargoTaxiAddRequestBody,
} from "./cargo-taxi/add/contracts-cargo-taxi-add.request";
import ContractsCargoTaxiAddResponse from "./cargo-taxi/add/contracts-cargo-taxi-add.response";
import ContractsCargoTaxiDetailsRequest from "./cargo-taxi/details/contracts-cargo-taxi-details.request";
import ContractsCargoTaxiDetailsResponse from "./cargo-taxi/details/contracts-cargo-taxi-details.response";
import ContractsCargoTaxiListRequest, {
  ContractsCargoTaxiListRequestQueryParams,
} from "./cargo-taxi/list/contracts-cargo-taxi-list-request";
import contractsCargoTaxiListRequestFactory from "./cargo-taxi/list/contracts-cargo-taxi-list-request.factory";
import ContractsCargoTaxiListResponse from "./cargo-taxi/list/contracts-cargo-taxi-list.response";
import contractCargoTaxiUpdateRequestFactory from "./cargo-taxi/update/contracts-cargo-taxi-update-request.factory";
import ContractCargoTaxiUpdateRequest, {
  ContractCargoTaxiUpdateRequestBody,
} from "./cargo-taxi/update/contracts-cargo-taxi-update.request";
import ContractCargoTaxiUpdateResponse from "./cargo-taxi/update/contracts-cargo-taxi-update.response";
import contractsMileageAddRequestFactory from "./mileage/add/contracts-mileage-add-request.factory";
import ContractsMileageAddRequest from "./mileage/add/contracts-mileage-add.request";
import ContractsMileageAddResponse from "./mileage/add/contracts-mileage-add.response";
import contractsMileageCargoCompanyDetailsRequestFactory from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details-request.factory";
import ContractsMileageCargoCompanyDetailsRequest from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details.request";
import ContractsMileageCargoCompanyDetailsResponse from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details.response";
import ContractsMileageDetailsRequest from "./mileage/details/contracts-mileage-details.request";
import ContractsMileageDetailsResponse from "./mileage/details/contracts-mileage-details.response";
import contractsMileageListRequestFactory from "./mileage/list/contracts-mileage-list-request.factory";
import ContractsMileageListRequest from "./mileage/list/contracts-mileage-list.request";
import ContractsMileageListResponse from "./mileage/list/contracts-mileage-list.response";
import ContractsMileageTemplateResponse from "./mileage/template/contracts-mileage-template.response";
import contractsMileageUpdateRequestFactory from "./mileage/update/contracts-mileage-update-request.factory";
import ContractsMileageUpdateRequest from "./mileage/update/contracts-mileage-update.request";
import ContractsMileageUpdateResponse from "./mileage/update/contracts-mileage-update.response";
import contractsTaxiDriverAddRequestFactory from "./taxi-driver/add/contracts-taxi-driver-add-request.factory";
import ContractTaxiDriverAddRequest, {
  ContractTaxiDriverAddRequestBody,
} from "./taxi-driver/add/contracts-taxi-driver-add.request";
import ContractTaxiDriverAddResponse from "./taxi-driver/add/contracts-taxi-driver-add.response";
import ContractsTaxiDriverDetailsRequest from "./taxi-driver/details/contracts-taxi-driver-details.request";
import ContractsTaxiDriverDetailsResponse from "./taxi-driver/details/contracts-taxi-driver-details.response";
import contractsTaxiDriverUpdateRequestFactory from "./taxi-driver/update/contracts-taxi-driver-update-request.factory";
import ContractsTaxiDriverUpdateRequest, {
  ContractsTaxiDriverUpdateRequestBody,
} from "./taxi-driver/update/contracts-taxi-driver-update.request";
import ContractsTaxiDriverUpdateResponse from "./taxi-driver/update/contracts-taxi-driver-update.response";
import contractsTaxiForwardingContractAddRequestFactory from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add-request.factory";
import ContractsTaxiForwardingContractAddRequest, {
  ContractsTaxiForwardingContractAddRequestBody,
} from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add.request";
import ContractsTaxiForwardingContractAddResponse from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add.response";
import ContractsTaxiForwardingContractRequest from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract.request";
import ContractsTaxiForwardingContractResponse from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract.response";
import ContractsTaxiForwardingContractDetailsRequest from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details.request";
import ContractsTaxiForwardingContractDetailsResponse from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details.response";
import contractsTaxiForwardingContractListRequestFactory from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list-request.factory";
import ContractsTaxiForwardingContractListRequest, {
  ContractsTaxiForwardingContractListRequestQueryParams,
} from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list.request";
import ContractsTaxiForwardingContractListResponse from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list.response";
import contractsTaxiForwardingContractUpdateRequestFactory from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update-request.factory";
import ContractsTaxiForwardingContractUpdateRequest, {
  ContractsTaxiForwardingContractUpdateRequestBody,
} from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update.request";
import ContractsTaxiForwardingContractUpdateResponse from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update.response";
import ContractsValidCollectionRequest from "./valid-collection/contracts-valid-collection.request";
import ContractsValidCollectionResponse from "./valid-collection/contracts-valid-collection.response";

const contractsApiService = () => {
  const getValidCollection = async (
    request: ContractsValidCollectionRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsValidCollectionResponse> => {
    const url = `/contracts/cargo-companies/${request.cargoCompanyId}/valid-collection`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getCargoTaxiContractList = (
    request: ContractsCargoTaxiListRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsCargoTaxiListResponse> => {
    const url = `/contracts/cargo-taxi`;

    const queryParams: ContractsCargoTaxiListRequestQueryParams =
      contractsCargoTaxiListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const addCargoTaxiContract = (
    request: ContractsCargoTaxiAddRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsCargoTaxiAddResponse> => {
    const url = `/contracts/cargo-taxi`;

    const body: ContractsCargoTaxiAddRequestBody =
      contractsCargoTaxiAddRequestFactory.createBody(request);

    return railyApiService().post<ContractsCargoTaxiAddResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const updateCargoTaxiContract = (
    request: ContractCargoTaxiUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractCargoTaxiUpdateResponse> => {
    const url = `/contracts/cargo-taxi/${request.contractId}`;

    const body: ContractCargoTaxiUpdateRequestBody =
      contractCargoTaxiUpdateRequestFactory.createBody(request);

    return railyApiService().put<ContractCargoTaxiUpdateResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const getCargoTaxiContractDetails = (
    request: ContractsCargoTaxiDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsCargoTaxiDetailsResponse> => {
    const url = `/contracts/cargo-taxi/${request.contractId}`;

    return railyApiService().get<ContractsCargoTaxiDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const getContractMileageCargoCompanyDetails = async (
    request: ContractsMileageCargoCompanyDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageCargoCompanyDetailsResponse> => {
    const url = `/contracts/mileage/cargo-company/${request.cargoCompanyUuid}`;

    const queryParams =
      contractsMileageCargoCompanyDetailsRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getTaxiForwardingContract = (
    request: ContractsTaxiForwardingContractRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiForwardingContractResponse> => {
    const url = `/contracts/taxi-forwarding?producer_taxi_id=${request.producerId}&consumer_taxi_id=${request.selectedTaxiCorporationId}&is_valid=true`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const addTaxiDriverContract = (
    request: ContractTaxiDriverAddRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractTaxiDriverAddResponse> => {
    const url = `/contracts/taxi-driver`;

    const body: ContractTaxiDriverAddRequestBody =
      contractsTaxiDriverAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const addTaxiForwardingContract = (
    request: ContractsTaxiForwardingContractAddRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiForwardingContractAddResponse> => {
    const url = `/contracts/taxi-forwarding`;

    const body: ContractsTaxiForwardingContractAddRequestBody =
      contractsTaxiForwardingContractAddRequestFactory.createBody(request);

    return railyApiService().post<ContractsTaxiForwardingContractAddResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const getTaxiForwardingContractList = async (
    request: ContractsTaxiForwardingContractListRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiForwardingContractListResponse> => {
    const url = `/contracts/taxi-forwarding`;

    const queryParams: ContractsTaxiForwardingContractListRequestQueryParams =
      contractsTaxiForwardingContractListRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().get<ContractsTaxiForwardingContractListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const updateTaxiForwardingContract = (
    request: ContractsTaxiForwardingContractUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiForwardingContractUpdateResponse> => {
    const url = `/contracts/taxi-forwarding/${request.contractUuid}`;

    const body: ContractsTaxiForwardingContractUpdateRequestBody =
      contractsTaxiForwardingContractUpdateRequestFactory.createBody(request);

    return railyApiService().put<ContractsTaxiForwardingContractUpdateResponse>(
      {
        url,
        abortSignal,
        body,
      },
    );
  };

  const getTaxiForwardingContractDetails = (
    request: ContractsTaxiForwardingContractDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiForwardingContractDetailsResponse> => {
    const url = `/contracts/taxi-forwarding/${request.contractUuid}`;

    return railyApiService().get<ContractsTaxiForwardingContractDetailsResponse>(
      {
        url,
        abortSignal,
      },
    );
  };

  const updateTaxiDriverContract = (
    request: ContractsTaxiDriverUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiDriverUpdateResponse> => {
    const url = `/contracts/taxi-driver/${request.contractId}`;

    const body: ContractsTaxiDriverUpdateRequestBody =
      contractsTaxiDriverUpdateRequestFactory.createBody(request);

    return railyApiService().put<ContractsTaxiDriverUpdateResponse>({
      url,
      abortSignal,
      body,
    });
  };

  const getTaxiDriverContractDetails = (
    request: ContractsTaxiDriverDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsTaxiDriverDetailsResponse> => {
    const url = `/contracts/taxi-driver/${request.contractId}`;

    return railyApiService().get<ContractsTaxiDriverDetailsResponse>({
      url,
      abortSignal,
    });
  };

  const getMileageContractList = async (
    request: ContractsMileageListRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageListResponse> => {
    const url = `contracts/mileage`;

    const queryParams =
      contractsMileageListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      queryParams,
      abortSignal,
    });
  };

  const addMileageContract = async (
    request: ContractsMileageAddRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageAddResponse> => {
    const url = `/contracts/mileage`;

    const body = contractsMileageAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const updateMileageContract = async (
    request: ContractsMileageUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageUpdateResponse> => {
    const url = `/contracts/mileage/${request.contractUuid}`;

    const body = contractsMileageUpdateRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const getMileageContractTemplate = async (
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageTemplateResponse> => {
    const url = `/contracts/mileage/template`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getMileageContractDetails = (
    request: ContractsMileageDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<ContractsMileageDetailsResponse> => {
    const url = `/contracts/mileage/${request.contractUuid}`;

    return railyApiService().get<ContractsMileageDetailsResponse>({
      url,
      abortSignal,
    });
  };

  return {
    getValidCollection,
    getCargoTaxiContractList,
    addCargoTaxiContract,
    updateCargoTaxiContract,
    getCargoTaxiContractDetails,
    getContractMileageCargoCompanyDetails,
    getTaxiForwardingContract,
    addTaxiDriverContract,
    addTaxiForwardingContract,
    getTaxiForwardingContractList,
    updateTaxiForwardingContract,
    getTaxiForwardingContractDetails,
    updateTaxiDriverContract,
    getTaxiDriverContractDetails,
    addMileageContract,
    getMileageContractList,
    updateMileageContract,
    getMileageContractTemplate,
    getMileageContractDetails,
  };
};

export default contractsApiService;
